import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { p11n } from '@ucheba/utils/helpers/string'
import { divisionsSelector } from '@ucheba/store/institutions/divisions'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Divider } from '@ucheba/ui/components/Divider/desktop'
import { Progress } from '@ucheba/ui/components/Progress/desktop'
import { ELoading } from '@ucheba/store/utils/response/types'
import { Banner } from '../../../../../components/Banner/desktop'
import LayoutInstitution from '../../../../../components/LayoutInstitution/desktop'
import { InstitutionsList } from '../../../../../components/InstitutionsList/desktop'
import Pagination from '../../components/Pagination/desktop'
import DivisionsNavigation from '../components/Navigation'
import { useDivisionsDataFetching } from '../bll/useDivisionsDataFetching'
import { LoaderWrapper } from '../styles'
import { useBannerProgramTypes } from '../../utils/useBannerProgramTypes'
import { isPaidPackage } from '../../utils/isPaidPackage'

const InstitutionUnitsPage: FC = () => {
  const currentDivisions = useDivisionsDataFetching()

  const loadingData = useSelector(divisionsSelector.loading)

  const { extraParams, paidPackage } = useBannerProgramTypes()

  return (
    <>
      <LayoutInstitution>
        <Heading as='h1' h2='Факультеты и филиалы' spacing='null' />

        <Spacing spacing='large' />

        <DivisionsNavigation />

        <Spacing spacing='xlarge' />

        {loadingData === ELoading.pending ? (
          <>
            <LoaderWrapper>
              <Progress />
            </LoaderWrapper>
          </>
        ) : (
          <>
            {!!currentDivisions?.items?.length && (
              <InstitutionsList
                isBanner={!isPaidPackage(paidPackage)}
                params={extraParams}
                items={currentDivisions?.items}
                isLogo={false}
                shortName
              />
            )}
          </>
        )}

        {currentDivisions?.total > 15 && (
          <>
            <Divider />

            <Pagination
              showItemsCount={15}
              totalCount={`${currentDivisions?.total} ${p11n(
                currentDivisions?.total || 0,
                'подразделение',
                'подразделения',
                'подразделений'
              )}`}
              total={currentDivisions?.total}
            />
          </>
        )}

        <Spacing spacing='uxlarge' />
      </LayoutInstitution>

      {!isPaidPackage(paidPackage) && <Banner id={6} extraParams={extraParams} />}

      {!isPaidPackage(paidPackage) && <Banner id={14} extraParams={extraParams} />}
    </>
  )
}

export default InstitutionUnitsPage
